
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/floating-button",
      function () {
        return require("private-next-pages/components/floating-button.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/floating-button"])
      });
    }
  